import styled from 'styled-components'

import { outline } from 'components/Editor/styled/Outline'

const UnstyledButton = styled.button`
  all: unset;
  cursor: pointer;
  ${outline}
`

export default UnstyledButton
